<div class="table-container">
  <p-table #dt 
           [value]="rowsResults()" 
           [responsiveLayout]="'scroll'" 
           [scrollable]="true" 
           scrollDirection="horizontal"
           class="results-table"
           [paginator]="usePagination"
           [rows]="rowsPerPage">
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of columnsResults(); let i = index"
            [pSortableColumn]="col.field"
            [ngClass]="{'frozen-column': i === 0}"
            class="custom-column">
          <div class="column-header-container">
            <div class="header-title">{{ col.header }}</div>
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr>
        <td *ngFor="let col of columnsResults(); let i = index"
            [ngClass]="{'frozen-column': i === 0}">

            {{ row[col.field] | valueFormat: col.field }}

        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
